import { createMuiTheme } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

const theme: Theme = createMuiTheme({
  palette: {
    primary: {
      main: '#FF5A0F',
    },
    secondary: {
      main: '#00A16B',
      contrastText: '#ffffff',
    },
  },
  overrides: {
    MuiTypography: {
      h1: {
        fontSize: '48px',
        fontWeight: 400,
      },
      h2: {
        fontSize: '32px',
        fontWeight: 400,
      },
      h3: {
        fontSize: '24px',
        fontWeight: 300,
      },
      h4: {
        fontSize: '20px',
        fontWeight: 300,
      },
      h5: {
        fontSize: '16px',
        fontWeight: 300,
      },
      h6: {
        fontSize: '12px',
        fontWeight: 300,
      },
    },
  },
  balljames: {
    spacing: {
      xl: 32,
      m: 24,
      s: 12,
    },
  },
});

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    balljames: {
      spacing: {
        xl: number;
        m: number;
        s: number;
      };
    };
  }
  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    balljames: {
      spacing: {
        xl: number;
        m: number;
        s: number;
      };
    };
  }
}

export default theme;
